export const API_URL = '/v2/api/ui';
// export const API_URL = '/api';
